export default __webpack_public_path__ + "static/media/react-redux.45917d58.png";